module.exports = new __parcel__URL__("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg").toString();